import React from 'react'
import '../index.css'
import { Box, Grid2, Paper, Typography } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';

const Header = () => {
    return (
        <Box  className="headerLayout" style={{}}>
            <Grid2 container>
                <Grid2 size={2}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', paddingLeft: 50, paddingTop: 17, paddingBottom: 17, paddingRight: 50 }}>
                        <img src="/images/Logo.png" style={{ width: 40, height: 40 }} />
                        <div>
                            <img src="/images/Briezi.png" style={{ width: '100%', height: 32, marginLeft: 4 }} />
                        </div>
                    </div>
                </Grid2>
                <Grid2 sx={{ alignItems: 'center', display: 'flex', flexDirection: 'row' }} size={7}>
                    <Box>
                        <Typography>Welcome - </Typography>
                    </Box>
                    <Box>
                        <Typography color='#4DA235'> Shriram Life!</Typography>
                    </Box>
                </Grid2>
                <Grid2 sx={{ alignItems: 'center', display: 'flex', flexDirection: 'row', justifyContent:'space-evenly', }} size={3}>
                    <Box>
                        <NotificationsIcon color='#2CA51C' />
                    </Box>
                    <Box>
                        <img src="/images/shriram-logo.png" style={{ width: 107, height: 51, marginLeft: 4 }} />
                    </Box>
                    <Box>
                    <Typography>Shriram Life</Typography>
                    <Typography variant='caption'>Admin</Typography>
                    </Box>
                </Grid2>
            </Grid2>
        </Box>
    )
}

export default Header;
